module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "collectProductContent"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n    商品收藏 \n    \n    "), (_vm.isManage) ? _c('div', {
    staticClass: "cancelManageCollect"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "取消管理"
    },
    on: {
      "click": function($event) {
        return _vm.manageCollect(false)
      }
    }
  })]) : _c('div', {
    staticClass: "manageCollect"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "收藏管理"
    },
    on: {
      "click": function($event) {
        return _vm.manageCollect(true)
      }
    }
  })]), _vm._v(" "), (_vm.isManage) ? _c('div', {
    staticClass: "delCollect",
    on: {
      "click": _vm.delCollect
    }
  }, [_c('img', {
    attrs: {
      "src": "https://file-sz.fjjykj.com.cn/Supply/s4fa98fed29b1ec7c9825589935fabd4a.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelName"
  }, [_vm._v("删除")])]) : _vm._e(), _vm._v(" "), (_vm.isManage) ? _c('div', {
    staticClass: "allSelect"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckboxChange
    },
    model: {
      value: (_vm.isAll),
      callback: function($$v) {
        _vm.isAll = $$v
      },
      expression: "isAll"
    }
  }), _c('span', {
    staticClass: "labelName",
    on: {
      "click": _vm.allSelect
    }
  }, [_vm._v("全选")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    key: _vm.collectProductIndex,
    staticClass: "collectProductList"
  }, [(_vm.productList.length > 0) ? _c('ul', _vm._l((_vm.productList), function(item, i) {
    return _c('li', {
      key: 'goods_' + i
    }, [_c('div', {
      staticClass: "recommendProductImage"
    }, [_c('img', {
      staticClass: "recommendImg",
      attrs: {
        "src": item.defaultImage
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }), _vm._v(" "), _vm._l((item.labels), function(labelItem, labelIndex) {
      return (labelIndex < 1 && labelItem.labelIcon && !_vm.isManage) ? _c('img', {
        key: labelIndex,
        staticClass: "productIcon",
        attrs: {
          "src": labelItem.labelIcon
        }
      }) : _vm._e()
    }), _vm._v(" "), (_vm.isManage) ? _c('div', {
      staticClass: "selectProduct"
    }, [_c('el-checkbox', {
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "delProduct"
    }, [_c('img', {
      attrs: {
        "src": "https://file-sz.fjjykj.com.cn/Supply/s7700d715392bcc97de0073f0ed076c23.png"
      },
      on: {
        "click": function($event) {
          return _vm.delCollectItem(item.id)
        }
      }
    })])], 2), _vm._v(" "), _c('div', {
      staticClass: "productname",
      staticStyle: {
        "height": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "productprice"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("\n              ￥" + _vm._s(item.settlementPrice) + "\n                "), (item.settlementPrice < item.sellPrice) ? _c('span', {
      staticClass: "scribe"
    }, [_vm._v("\n                  ￥" + _vm._s(item.sellPrice) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "sales"
    }, [_vm._v("\n                成交" + _vm._s(item.sales) + "件\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "operationBtn"
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.toGoodsDetail(item.id)
        }
      }
    }, [_c('y-button', {
      attrs: {
        "text": "查看详情"
      }
    })], 1), _vm._v(" "), _c('y-button', {
      attrs: {
        "text": "加入购物车",
        "classStyle": "main-btn"
      },
      on: {
        "btnClick": function($event) {
          return _vm.showModal(item)
        }
      }
    })], 1)])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.productList.length > 0) ? _c('div', {
    staticClass: "collectPaging"
  }, [_c('el-pagination', {
    attrs: {
      "page-size": _vm.queryForm.MaxResultCount,
      "current-page": _vm.queryForm.SkipCount,
      "layout": "prev, pager, next, jumper",
      "total": _vm.goodsTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryForm, "SkipCount", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryForm, "SkipCount", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('selectSpec', {
    ref: "selectSpec"
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28c47fe6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CollectProductList.vue
// module id = 749
// module chunks = 2